import {FormElement} from "./FormElement";
import {FormBuilder} from "../FormBuilder";
import {SchemaField} from "../../Infrastructure/Server/SchemaField";
const $ = jQuery;

export class RadioFormElement extends FormElement {

    radiosjQueryObject: any;

    constructor(options: SchemaField, formBuilder: FormBuilder, external: {[key: string]: any}) {
        super(options, formBuilder, external);

        this.setOptions(options.options);
    }

    setDomElements() {
        super.setDomElements();
        this.radiosjQueryObject = $(this.domElements.main).find('input[type="radio"]');
    }

    setEventHandlers() {
        super.setEventHandlers();

        this.radiosjQueryObject.on('change', (e)=>{
            this.value = e.target.value;
            this.events.trigger('changed', this, [this]);
        });
    }
}